/* eslint-disable-next-line */
import { CommonModule } from '@angular/common';
import { NgModule, inject } from '@angular/core';
import { MorganaModule } from 'morgana';
import { throwIfAlreadyLoaded } from './module-import-guard';

@NgModule({
	declarations: [],
	imports: [
		CommonModule,
		MorganaModule,
	],
})
export class CoreModule {
	constructor() {
		const parentModule = inject(CoreModule, { optional: true, skipSelf: true });

		throwIfAlreadyLoaded(parentModule, 'CoreModule');
	}
}
